import Service from './service';

export default class ConsigneeService extends Service {
  baseApi = '/consignees';

  async getConsignees(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async updateConsignee(id, body) {
    const url = `${this.baseApi}/${id}`;
    return await this.putResource(url, body);
  }

  async createConsignee(body) {
    const url = `${this.baseApi}`;
    return await this.postResource(url, body);
  }
}
